'use client';

import SceneCanvas from '../../atoms/SceneCanvas/SceneCanvas';
import ScrollOverlay from '../../molecules/ScrollOverlay/ScrollOverlay';

export default function LandingHero() {
  return (
    <div id="scroll-container" className="relative w-full min-h-screen">
      {/* Fixed 3D canvas backdrop */}
      <SceneCanvas />
      
      {/* Scrollable text overlays */}
      <ScrollOverlay />
    </div>
  );
}
